import axios from 'axios'
import { ref } from 'vue'
import { APIS_DASHBOARD, APIS_TOPOLOGY, TIMEOUTTIME } from '@/constants/apis'
import { showConsoleError } from '@/functions/errors'
import { TYPES, STATUS, TOKEN } from '@/constants/labels'
import { ALARM_TYPE, EQUIPOS, OBJ_ALARM_TYPE, OBJ_OPERABILITY, OBJ_TOPOLOGY_STATUS, OPERABILITY } from '@/interfaces/SmartLink/Equipos'

import store from '@/store';

export async function getAlarmDashboard() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DASHBOARD.value.alarmtodash, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: ALARM_TYPE[] = response.data;
      const prevObj = ref<OBJ_ALARM_TYPE>({
        distri: [],
        acceso: [],
        client: [],
      })
      const showGraphs = ref(finalData.length > 0)

      const arrayDistri = ref<ALARM_TYPE[]>([])
      const arrayAcceso = ref<ALARM_TYPE[]>([])
      const arrayClient = ref<ALARM_TYPE[]>([])
      if (finalData.length > 0) {
        finalData.forEach((item: ALARM_TYPE) => {
          if (item.subtipo === TYPES.distri) arrayDistri.value.push(item)
          if (item.subtipo === TYPES.acceso) arrayAcceso.value.push(item)
          if (item.subtipo === TYPES.client) arrayClient.value.push(item)
        })

        prevObj.value = {
          distri: arrayDistri.value,
          acceso: arrayAcceso.value,
          client: arrayClient.value,
        }
      }

      statusAxios.value = { status: 200, data: prevObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getAllOperability() {
  try {
    const response = await axios.get(APIS_DASHBOARD.value.getOperability, {
      timeout: TIMEOUTTIME,
      headers: { "Authorization": `Bearer ${TOKEN}` }
    });

    const finalData = response.data;
    const hasData = finalData && Object.keys(finalData).length > 0;

    return {
      status: 200,
      data: finalData,
      showGraphs: hasData
    };
  } catch (error) {
    showConsoleError(error);
    return {
      status: 400,
      data: {
        distribucion: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
        acceso: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
        cliente: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 }
      },
      showGraphs: false
    };
  }
}

export async function getAlarmRecurrent() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_DASHBOARD.value.alarmrectodash, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: ALARM_TYPE[] = response.data;
      const prevObj = ref<ALARM_TYPE[]>([])
      const showGraphs = ref(finalData.length > 0)

      if (finalData.length > 0) {
        prevObj.value = finalData
      }
      statusAxios.value = { status: 200, data: prevObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}

export async function getAllStatusData() {

  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_TOPOLOGY.value.getAllTopoData, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<OBJ_TOPOLOGY_STATUS>({
        statusEquipData: [],
        countEquipData: {
          distri: { ok: 0, alarm: 0, alert: 0, down: 0 },
          acceso: { ok: 0, alarm: 0, alert: 0, down: 0 },
          client: { ok: 0, alarm: 0, alert: 0, down: 0 },
        }
      })
      const showGraphs = ref(finalData.length > 0)

      /**
       * Almacena en el store todo el array de objetos que trae la API, 
       * con el fin de reutilizarse en otra parte del proyecto y no hacer pedidos de nuevo a la api
       */
      store.commit('addAllItemsByStatus', finalData);

      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          if (item.subtipo === TYPES.distri && item.status) {
            item.status.toUpperCase() === STATUS.ok ? finalObj.value.countEquipData.distri.ok++ : null;
            item.status.toUpperCase() === STATUS.alarm ? finalObj.value.countEquipData.distri.alarm++ : null;
            item.status.toUpperCase() === STATUS.alert ? finalObj.value.countEquipData.distri.alert++ : null;
            item.status.toUpperCase() === STATUS.down ? finalObj.value.countEquipData.distri.down++ : null;
          }

          if (item.subtipo === TYPES.acceso && item.status) {
            item.status.toUpperCase() === STATUS.ok ? finalObj.value.countEquipData.acceso.ok++ : null;
            item.status.toUpperCase() === STATUS.alarm ? finalObj.value.countEquipData.acceso.alarm++ : null;
            item.status.toUpperCase() === STATUS.alert ? finalObj.value.countEquipData.acceso.alert++ : null;
            item.status.toUpperCase() === STATUS.down ? finalObj.value.countEquipData.acceso.down++ : null;
          }

          if (item.subtipo === TYPES.client && item.status) {
            item.status.toUpperCase() === STATUS.ok ? finalObj.value.countEquipData.client.ok++ : null;
            item.status.toUpperCase() === STATUS.alarm ? finalObj.value.countEquipData.client.alarm++ : null;
            item.status.toUpperCase() === STATUS.alert ? finalObj.value.countEquipData.client.alert++ : null;
            item.status.toUpperCase() === STATUS.down ? finalObj.value.countEquipData.client.down++ : null;
          }
        })
      }
      finalObj.value.statusEquipData = finalData;

      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}
